export default function Placeholder(props) {
    return <span {...props} className="merge-tag" contentEditable="false">
        {props.children}
    </span>
}
